import { color, Link, radius, spacing, typography } from '@gyym/ui'
import styled from 'styled-components'

import { FacilityLpBanner } from '@/components/UI/FacilityLpBanner'

export const ListItemLink = styled(Link)`
  ${typography('body1')}
  color: ${color('white')};
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  text-decoration: none;
`

interface UserGradeTextProps {
  type?: 'neutral' | 'positive' | 'negative'
  mt?: number
  size?: 'sm' | 'lg'
}

export const UserGrade = {
  Container: styled.div`
    display: flex;
    align-items: center;
    padding: ${spacing(3)};
    border-radius: ${radius('md')};
    background: rgba(255, 255, 255, 0.16);
    color: ${color('white')};
    width: 100%;
  `,
  Img: styled.img`
    width: 96px;
    border-radius: ${radius('full')};
  `,
  Label: styled.div`
    ${typography('caption2')};
    text-align: center;
  `,
  Content: styled.div`
    margin-left: ${spacing(3)};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  `,
  ContentInner: styled.div``,
  Text: styled.div<UserGradeTextProps>`
    ${({ size = 'sm' }) =>
      size === 'lg' ? typography('headline3') : typography('subhead3')}
    color: ${({ type = 'neutral', theme }) => {
      switch (type) {
        case 'positive':
          return '#A3D1F1'
        case 'negative':
          return theme.colors.red['02']
        case 'neutral':
        default:
          return theme.colors.white
      }
    }};
    margin-top: ${({ theme, mt = 0 }) => mt && theme.spacing(mt)};
  `,
}

export const Badge = styled.div`
  ${typography('subhead2')};
  margin-left: auto;
  border-radius: ${radius('full')};
  height: 24px;
  padding: ${spacing(0, 3)};
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.16);
  color: ${color('white')};
`

export const StyledFacilityLpBanner = styled(FacilityLpBanner)`
  margin: 0 auto;
  width: 100%;
`

export const LabelInner = styled.span`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};

  & > svg {
    color: ${color('red.01')};
    width: 16px;
    height: 16px;
    max-width: 16px;
    max-height: 16px;
  }
`
